import React from 'react';

/**
 * Marks content so browser auto-translate is less likely to rewrite it
 * (proper nouns, master labels, system status values).
 */
function NoTranslate({ children, className = '', as: Component = 'span', ...rest }) {
  const merged = ['notranslate', className].filter(Boolean).join(' ');
  return (
    <Component translate="no" className={merged} {...rest}>
      {children}
    </Component>
  );
}

export default NoTranslate;
